export const INPUT_SIZE = 3000;
export const USER_IDEAL_TIME = 14300;
export const SESSION_WARNING_MODAL_DISPLAY_TIME = 300;
export const RETRY_JOB_STORAGE_KEY = 'supportRetryRedeemJobs';
export const RETRY_JOB_POLL_DELAY_MS = 5000;
